import { FC } from 'react';
import { IBookDetailData } from '@/interfaces/bookDetail.interface';
import { IReviews } from '@/interfaces/reviews.interface';
import { json } from 'stream/consumers';
import { removeAllBrackertsFromString } from '@/helpers/helpers';

interface IEbookJsonMarkup {
  book: IBookDetailData;
  authorFullName: string;
  reviews: IReviews;
}

const EbookJsonMarkup: FC<IEbookJsonMarkup> = ({ book, authorFullName, reviews }) => {
  const bookType = book.type === 'book' || book.type === 'pdf' ? `Book` : `Audiobook`;
  const description = removeAllBrackertsFromString(`${book.book.description}`);

  const reviewsContent = `
    "review": {
      "@type": "Review",
      "author": {"@type": "Person", "name": "${!!reviews.data ? reviews.data[0]?.name : ''}"},
      "reviewBody": "${!!reviews.data ? reviews.data[0]?.message : ''}"},`;

  const readUrl = `https://fantasy-worlds.ru/lib/id${book.id}/read`;

  const getBookJsonMarkup = () => {
    return {
      __html: `
      { "@context": "https://schema.org","@type": "${bookType}",
          "bookFormat": "https://schema.org/EBook","name":"${book.book.title}",
          "author": {"@type": "Person","name": "${authorFullName}"},
          "illustrator": {"@type": "Person","name": "${authorFullName}"},
          "abstract": "${description}",
        "workExample": {"@type": "${bookType}",
          "url": "${readUrl}","name": "Читать первую главу бесплатно"},
        "aggregateRating": {"@type": "AggregateRating","ratingValue": "${book.rating}","bestRating": "5","ratingCount": "${book.voted_users}"},
        ${!!reviews.data && reviews.data.length > 0 ? reviewsContent : ``}
        "accessibilityFeature": ["largePrint","highContrast","alternativeText"],
        "potentialAction": {"@type": "ReadAction","target": "${readUrl}"}
      }`,
    };
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={getBookJsonMarkup()} key="product-jsonld" />;
};

export default EbookJsonMarkup;
